import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import React from 'react'
import {GiIronCross} from 'react-icons/gi'
import {RiCircleFill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {renderIf, renderSelf} from 'views/Shared'
import {flatten_rows, getLinkToDetailRow} from './codiHelpers'

const LinkItem = ({ item, style, className, params }) => {
  const { key, link } = item ?? {}
  const { content, codi_document_page, short_index_name } = link ?? {}
  const { codi_document } = codi_document_page ?? {}
  return renderIf(
    item,
    <div className="space-x-1 text-xs italic">
      <RiCircleFill
        size={8}
        className="text-color-500"
      />
      {
        renderIf(
          short_index_name,
          <Link
            className={classNames('font-bold text-primary', className)}
            style={style}
            target="_blank"
            to={getLinkToDetailRow(link)}>
            {short_index_name}{renderIf(content, ': ')}
          </Link>
        )
      }
      {renderIf(content, <span className="text-color-300">{content}</span>)}
    </div>
  )
}

const CodiLinks = ({
  row,
  style,
  className,
  filterActions,
  render = renderSelf,
  Placeholder = EmptyHolder,
}) => {
  const links = flatten_rows(row, 'links')

  if (_.isEmpty(links)) {
    return <Placeholder />
  }

  const groups = _(links)
    .groupBy(({ group_id }) => group_id)
    .map((value, key) => ({
      id: key,
      data: value,
      title: _.find(links, { group_id: key })?.group_title,
    }))
    .value()

  return (
    render(
      <div
        style={style}
        className={classNames('flex flex-col space-y-3', className)}>
        {groups.map(({ id, title, data }) => {
          const children = Array.from(data ?? [])
          return (
            <div
              key={id}
              className="flex flex-col gap-1">
              <span className="flex items-baseline gap-2 text-sm italic">
                <GiIronCross
                  size={10}
                  className="text-color-300"
                />
                <span className="flex-1 font-bold text-color-000">{title}</span>
              </span>
              <div className="ml-2 space-y-1">
                {_.sortBy(children, ['key']).map((item, index) => (
                  <LinkItem
                    key={index}
                    item={item}
                    params={{
                      filterActions,
                    }}
                  />
                ))}
              </div>
            </div>
          )
        })}
      </div>
    ) ?? null
  )
}

export default CodiLinks
